export default class AitiCoreTranslator {

    private _translations: object = {};

    constructor() {
        this._mageTranslateFallback();

        if (typeof window._ !== 'undefined') {
            throw new Error('Global function _ is already declared');
        }

        window._ = this.translate.bind(this);
        if (typeof process === 'object') {
            global._ = window._;
        }

        if (typeof window._aitiCoreTranslations !== 'undefined') {
            this.add(window._aitiCoreTranslations);
        }
    }

    /**
     * Adds translation(s) by key(s).
     *
     * @param {string|object.<string, string>} translations
     *
     * @example
     * add('Order', 'Objednávka')
     * add({'Order': 'Objednávka', 'Invoice': 'Faktura', ...})
     */
    add(...translations) {
        if (arguments.length > 1) {
            this._translations[arguments[0]] = arguments[1];
        } else if (typeof arguments[0] === 'object') {
            for (let key in arguments[0]) {
                if (!arguments[0].hasOwnProperty(key)) {
                    continue;
                }

                this._translations[key] = arguments[0][key];
            }
        }
    }

    /**
     * Translates text by translation key.
     * Supports sprintf format (%s, %d, ...).
     *
     * @alias window._
     * @param {string} key
     * @param {...?*} params
     * @returns {string}
     *
     * @example
     * translate('Order') // output: "Objednávka"
     * translate('Order %s', 123456) // output: "Objednávka 123456"
     * translate('Name %s - count %d', 'foo', 10) // output: "Name foo - count 10"
     */
    translate(key: string, ...params: any[]): string {
        if (!this._translations.hasOwnProperty(key)) {
            return key;
        }

        return sprintf(this._translations[key], ...params);
    }

    /**
     * Backward compatibility for old Translate class
     * @see js/mage/translate.js
     */
    private _mageTranslateFallback() {
        let _this = this;

        window.Translate = function(args) {
            /**
             * @deprecated use AitiCore.getTranslator().add(...)
             */
            this.add = function(...args) {
                _this.add(...args);
            };

            /**
             * @deprecated use window._ or AitiCore.getTranslator().translate(...)
             */
            this.translate = function(key: string, ...args) {
                return _this.translate(key, ...args);
            };

            this.add(args);
        };
    }
}

declare global {
    const _: typeof AitiCoreTranslator.prototype.translate;

    interface Window {
        _: typeof AitiCoreTranslator.prototype.translate;
        Translate: Function;
        _aitiCoreTranslations: Object;
    }
}
